import {
    SALES_LIST
} from './constant';

export const initStateFeed = {
    salesList: [],
    pagination:null
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case SALES_LIST: {
            return {
                ...state,
                salesList: action.payload?.data || [],
                pagination:action.payload?.pagination
            };
        }
        default:
            return state;
    }
};
